import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.bio.about.me': {
    id: 'profile.bio.about.me',
    defaultMessage: 'About Me',
    description: 'A section of a user profile',
  },
});

export default messages;
